import React from 'react';
import { Box, createStyles, Grid, makeStyles, Theme, Button } from '@material-ui/core';
import { connect, useDispatch, useSelector } from 'react-redux';
import { ContestLineup, StackConstraint } from './store/types';
import { clearBoostedPlayer, getContestLineups, getContestPlayers, getContestStacks, removeBoostedPlayer, setBoostedPlayer, setConstraints, setDiversity, setFightStacks, setGeneratedSlate, setPoolSize, setRunback, setUseCustomExposures, triggerContestGen } from './store/actions';
import { APIState } from '../utils/api/reducer';
import { AuthResponse } from '../preContest/store/types';
import { SubscriptionTierEnum } from '../common/enums';
import { UpgradeModal } from '../common/LockIcon';
import { useGetSlateInfoQuery, useGetSlates } from '../common/queries/slateQueries';
import { Stack, Slider, Hidden } from '@mui/material';
import moment from 'moment';
import { APIConstants } from '../utils/api/constants';
import StackConstraints from './StackConstraints';
import { getCookie, setCookie } from 'react-use-cookie';
import { useUserId } from '../utils/authentication';
import { showStackTabContestGen } from '../utils/stackConstants';
import { SelectInput, poolSizeOptions } from '../common/selectOptions';
import { FightStackSettings } from '../common/FightStackSettingsAdjuster/FightStackSettings';
import FightStackSettingsAdjuster from '../common/FightStackSettingsAdjuster';
import { SitesResponse, SlateResponse, SportsResponse } from '../common/store/types';
import { setBoostedTeamsAction, setRemovedTeamsAction, setSite, setSlate, setSport } from '../common/store/actions';
import SettingsSelectors from '../common/SettingsSelectors';
import UnauthenticatedView from '../common/UnauthenticatedView';
import { SettingsLoader } from '../common/SettingsLoader';
import NoSlatesView from '../common/NoSlatesView';
import GameControls from '../common/GameControls/GameControls';
import { CustomToolTip, toolTipText } from '../common/CustomToolTip';
import { TooltipSelectLabelStyledTypography } from '../common/Table/_components';
import { filterSlates } from '../common/helpers/SelectorHelpers';
import { initialConstraintState } from './store/reducer';
import { userSubscribed } from '../utils/authentication';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    backgroundColor: 'rgba(0, 118, 54, 0.15);',
    width: '100%',
    borderRadius: 3,
    padding: '7px 20px',
    position: 'relative',
    '& .hide': {
      display: 'none',
    },
    '& .MuiSlider-markLabel': {
      fontSize: '10px',
    }
  },
  clear: {
    backgroundColor: 'transparent',
  },
  advancedButton: {
    background: '#0042C1',
    width: '100%',
    color: 'white',
    fontFamily: "Inter",
  },
  signInButtonWrapper: {
    padding: 0,
  },
  signInButton: {
    width: '100%',
    border: '1px solid #0042C1',
    color: 'white',
    fontFamily: "Inter",
  },
  sliderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginLeft: 30,
    marginRight: 30,
    '& .MuiSlider-markLabel': {
      color: 'white',
    },
    // '& .MuiSlider-track': {
    //   backgroundColor: 'transparent',
    // }
  },
  sliderHeader: {
    opacity: 0.7,
    fontFamily: 'Inter',
    fontSize: '12px !important',

  },
  hideButton: {
    cursor: 'pointer',
    marginLeft: 12,
    textDecorationLine: 'underline',
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 500,
  },
  heading: {
    fontSize: 20,
    fontWeight: 700,
    fontFamily: 'Inter',
  },
  selectWrapper: {
    marginRight: 16,
    width: 200,
    textOverflow: 'wrap',
    '& .MuiFormLabel-root': {
      color: theme.palette.common.white,
      opacity: 0.7,
      padding: 4,
      fontFamily: 'Inter',
      fontSize: '12px',
      fontStyle: 'normal',
      fontHeight: 500,
      lineHeight: '20px',
    }
  },
  select: {
    width: 200,
    height: 36,
    color: theme.palette.common.white,
    borderRadius: 4,
    border: '1px solid rgba(255, 255, 255, 0.20)',
    background: '#000710',
    '& .MuiSvgIcon-root': {
      color: theme.palette.common.white,
    }
  },
  buttonWrapper: {
    height: 36,
  },
  button: {
    borderRadius: 3,
    background: '#0042C1',
    color: 'white',
    padding: '8px 16px',
    marginLeft: 8,
    height: 36,
    '&:hover': {
      background: '#0042C1',
    },
    '&:disabled': {
      backgroundColor: '#555555 !important',
      color: '#BEBEBE'
    }
  },
})
);

export const mlbStacks: { [key: string]: StackConstraint[] } = {
  'dk': [
    {
      primary: 5,
      secondary: 3,
      percent: .17
    },
    {
      primary: 5,
      secondary: 2,
      percent: .25
    },
    {
      primary: 5,
      secondary: 0,
      percent: .15
    },
    {
      primary: 4,
      secondary: 4,
      percent: .05
    },
    {
      primary: 4,
      secondary: 3,
      percent: .1
    },
    {
      primary: 4,
      secondary: 2,
      percent: 0
    },
    {
      primary: 4,
      secondary: 0,
      percent: .10
    },
    {
      primary: 3,
      secondary: 3,
      percent: .02
    },
  ],
  'ob': [
    {
      primary: 5,
      secondary: 2,
      percent: .15
    },
    {
      primary: 5,
      secondary: 0,
      percent: .15
    },
    {
      primary: 4,
      secondary: 3,
      percent: .2
    },
    {
      primary: 4,
      secondary: 2,
      percent: 0
    },
    {
      primary: 4,
      secondary: 0,
      percent: .30
    },
    {
      primary: 3,
      secondary: 3,
      percent: .0
    },
  ],
  'fd': [
    {
      primary: 4,
      secondary: 4,
      percent: .1
    },
    {
      primary: 4,
      secondary: 3,
      percent: .25
    },
    {
      primary: 4,
      secondary: 2,
      percent: .1
    },
    {
      primary: 4,
      secondary: 0,
      percent: .25
    },
    {
      primary: 3,
      secondary: 3,
      percent: .05
    },
  ],
  'yh': [
    {
      primary: 5,
      secondary: 3,
      percent: .17
    },
    {
      primary: 5,
      secondary: 2,
      percent: .25
    },
    {
      primary: 5,
      secondary: 0,
      percent: .15
    },
    {
      primary: 4,
      secondary: 4,
      percent: .05
    },
    {
      primary: 4,
      secondary: 3,
      percent: .1
    },
    {
      primary: 4,
      secondary: 2,
      percent: 0
    },
    {
      primary: 4,
      secondary: 0,
      percent: .10
    },
    {
      primary: 3,
      secondary: 3,
      percent: .02
    },
  ]
}

const marks = [
  {
    value: -2,
    label: 'Low Stakes',
  },
  {
    value: -1,
    label: '',
  },
  {
    value: 0,
    label: 'Marquee',
  },
  {
    value: 1,
    label: '',
  },
  {
    value: 2,
    label: 'High Stakes',
  },
];

interface ReduxProps {
  readonly selectedSport: SportsResponse;
  readonly selectedSite: SitesResponse;
  readonly selectedType: string;
  readonly selectedSlate: SlateResponse;
  readonly contestLineups: APIState<ContestLineup[]>;
  readonly authenticated: APIState<AuthResponse>;
  readonly boostedPlayers: { [key: string]: number };
  readonly poolSize: number;
  readonly loading: boolean;
  readonly stackConstraints: StackConstraint[];
  readonly runback: StackConstraint;
  readonly diversity: number;
  readonly fightStacks: FightStackSettings[];
  readonly useCustomExposures: boolean;
}

interface DispatchProps {
  readonly SetSport: (sport: SportsResponse) => void;
  readonly SetSite: (site: SitesResponse) => void;
  readonly SetSlate: (slate: SlateResponse) => void;
  readonly SetGeneratedSlate: (slate: SlateResponse) => void;
  readonly SetPoolSize: (slate: number) => void;
  readonly SetConstraints: (constraints: StackConstraint[]) => void;
  readonly SetRunback: (runback: StackConstraint) => void;
  readonly TriggerContestGen: (slateId: string, user: string, totalLineups: number, boostedPlayers: { [key: string]: number }, stackConstraints: StackConstraint[], fightStacks: FightStackSettings[], runback: number, diversity: number, removedTeams: string[], useCustomExposures: boolean) => void;
  readonly GetContestPlayers: (slateId: string, user: string) => void;
  readonly GetContestLineups: (slateId: string, user: string) => void;
  readonly GetContestStacks: (slateId: string, user: string) => void;
  readonly SetBoostedPlayer: (player: string, boostedValues: number) => void;
  readonly ClearBoostedPlayers: () => void;
  readonly SetDiversity: (diversity: number | number[]) => void;
  readonly SetFightStacks: (fightStacks: FightStackSettings[]) => void;
  readonly RemoveBoostedPlayer: (player: string, boostedValues: number) => void;
  readonly UseCustomExposures: (useCustomExposure: boolean) => void;
}

type Props = ReduxProps & DispatchProps;

const Settings = (props: Props) => {
  const classes = useStyles();
  const userId = useUserId();
  const auth = 'awe' + userId;
  const { selectedSite, useCustomExposures, selectedSlate, selectedSport, selectedType, authenticated, boostedPlayers, poolSize, loading, stackConstraints, runback, diversity, fightStacks, UseCustomExposures, SetDiversity, ClearBoostedPlayers, SetBoostedPlayer, SetGeneratedSlate, TriggerContestGen, SetPoolSize, SetConstraints, SetFightStacks, SetRunback, GetContestLineups, GetContestPlayers, GetContestStacks, RemoveBoostedPlayer } = props;
  const [hasPreviousSim, setHasPreviousSim] = React.useState(false);
  const [disableGenerate, setDisableGenerate] = React.useState(false);
  const [hideSettings] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [disableUpdateInfo, setDisableUpdateInfo] = React.useState(false);
  const baseUrl = process.env.REACT_APP_API_URL || '';
  const constraintCookieKey = `contestGenerator-stackConstraints`;
  const runbackCookieKey = `contestGenerator-runback`;
  const boostedPlayersCookieKey = `contestGenerator-boostedPlayers`;
  const lastGenerationTimestampCookieKey = `contestGenerator-timestamp`;
  const lastPoolSizeCookieKey = `contestGenerator-poolSize`;
  const savedStackConstraintKey = `contestGenerator-stackConstraints-${selectedSport.sport}-${selectedSite.site}-${selectedSlate.slateId}`;
  const savedTeamControlKey = `contestGenerator-teamControl-${selectedSport.sport}-${selectedSite.site}-${selectedSlate.slateId}`;
  const dispatch = useDispatch();
  const { data: updateInfo } = useGetSlateInfoQuery(selectedSlate?.slateId?.toString(), disableUpdateInfo || selectedSlate?.slateId === undefined)
  const { data, isLoading: slatesLoading } = useGetSlates('CONTESTGEN', false);
  const slates = data?.slates;
  const playersLoaded = useSelector((state: any) => state.contestGenerator.contestPlayers.status === APIConstants.SUCCEEDED);
  const players = useSelector((state: any) => state.contestGenerator.contestPlayers);
  const removedTeams = useSelector((state: any) => state.common.removedTeams);
  const isUserSubscribed = userSubscribed(authenticated, selectedSite, selectedSport);

  const setSize = (size: any) => {
    const maxForCore = 2000;
    
    if (tierLocked && size > maxForCore) {
      setOpenModal(true);
    } else {
      SetPoolSize(size);
    }
    setDisableGenerate(false)
  }
  const setDiversity = (diversity: number | number[]) => {
    SetDiversity(diversity);
    setDisableGenerate(false)
  }

  const setStackExposures = (newConstraints: StackConstraint[], runback: StackConstraint) => {
    SetConstraints(newConstraints);
    SetRunback(runback);
    // UseCustomExposures(useCustomExposure);
    setDisableGenerate(false);
  }

  const handleFightStacksChange = (newSettings: FightStackSettings[]) => {
    SetFightStacks(newSettings);
    setDisableGenerate(false);
  }

  const onGenerate = () => {
    setCookie(constraintCookieKey, JSON.stringify(stackConstraints), { days: 2 });
    setCookie(runbackCookieKey, JSON.stringify(runback), { days: 2 });
    setCookie(boostedPlayersCookieKey, "{}");
    ClearBoostedPlayers();
    setCookie(lastGenerationTimestampCookieKey, `(${new Date().toLocaleDateString([], { month: 'short', day: '2-digit', timeStyle: undefined })} - ${new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} EST)`)
    setHasPreviousSim(false);
    TriggerContestGen(selectedSlate?.slateId, auth, poolSize, boostedPlayers, selectedSlate.type?.toUpperCase() === 'SHOWDOWN' ? [] : stackConstraints, fightStacks, selectedSlate.type?.toUpperCase() === 'SHOWDOWN' ? 0 : runback.percent, diversity, selectedSlate?.type?.toUpperCase() !== 'SHOWDOWN' ? removedTeams : [], useCustomExposures);
    SetGeneratedSlate(selectedSlate);
    setDisableGenerate(true);
  }

  const bringBack = () => {
    const oldConstraints: StackConstraint[] = getCookie(constraintCookieKey) ? JSON.parse(getCookie(constraintCookieKey)) : [];
    const oldRunback: StackConstraint = getCookie(runbackCookieKey) ? JSON.parse(getCookie(runbackCookieKey)) : {};
    const oldBoosted = getCookie(boostedPlayersCookieKey) ? JSON.parse(getCookie(boostedPlayersCookieKey)) : {};
    const oldPoolSize = parseInt(getCookie(lastPoolSizeCookieKey)) || 0;

    setPoolSize(oldPoolSize);
    if (oldBoosted) {
      Object.keys(oldBoosted)?.forEach(x => SetBoostedPlayer(x, oldBoosted[x]));
    }
    SetConstraints(oldConstraints);
    SetRunback(oldRunback);

    SetGeneratedSlate(selectedSlate);
    GetContestPlayers(selectedSlate?.slateId?.toString(), auth);
    GetContestLineups(selectedSlate?.slateId?.toString(), auth);
    GetContestStacks(selectedSlate?.slateId?.toString(), auth);
    setHasPreviousSim(false);
    setDisableGenerate(true);
  }
  const tierLocked = authenticated?.data?.authTier !== SubscriptionTierEnum[SubscriptionTierEnum.SIMS_MAX] &&
    authenticated?.data?.authTier !== SubscriptionTierEnum[SubscriptionTierEnum.MVP];

  async function fetchFightMatchups() {
    const response = await fetch(baseUrl + `/api/slatedata/fightsBySlate?slateId=${selectedSlate?.slateId}`);
    const json = await response.json();
    SetFightStacks(json);
  };

  const handleBoost = (boostedTeams: { [key: string]: number }, prevBoostedTeams?: { [key: string]: number }) => {
    const teams = Object.keys(boostedTeams);
    const prevTeams = Object.keys(prevBoostedTeams || {});

    if ((teams?.length > 0 || prevTeams?.length > 0) && players.status === APIConstants.SUCCEEDED) {
      players.data.forEach((player: any) => {
        const boostedId = `${player.nameAndId}|${player.position}`;

        if (teams.includes(player.team)) {
          if (selectedSport.sport?.toLowerCase() === 'mlb' && player.position?.toLowerCase().includes('p')) {
            return;
          } else {
            SetBoostedPlayer(boostedId, boostedTeams[player.team]);
          }
        } else if (prevTeams.includes(player.team)) {
          RemoveBoostedPlayer(boostedId, 0);
        }
      })
    }
  }

  React.useEffect(() => {
    if (selectedSite && selectedSport && selectedSlate) {
      const savedTeamControl = localStorage.getItem(`boostOwnership-${savedTeamControlKey}`);
      if (savedTeamControl) {
        dispatch(setBoostedTeamsAction(JSON.parse(savedTeamControl)));
      }
    }
  }, [selectedSport, selectedSite, selectedSlate])

  React.useEffect(() => {
    if (selectedSlate?.sport?.toLowerCase() === 'mma') {
      fetchFightMatchups();
    }
  }, [selectedSlate]);

  React.useEffect(() => {
    if (updateInfo && selectedSlate?.slateId?.toString()) {
      setDisableUpdateInfo(true);
    }
    else {
      setDisableUpdateInfo(false);
    }
  }, [updateInfo]);

  React.useEffect(() => {
    if (selectedSlate?.slateId?.toString()) {
      setDisableUpdateInfo(false);
    }
  }, [selectedSlate]);

  React.useEffect(() => {
    const savedConstraints = localStorage?.getItem(savedStackConstraintKey);
    if (savedConstraints) {
      const parsedSavedConstraints = JSON.parse(savedConstraints)
      setStackExposures(parsedSavedConstraints.constraints, parsedSavedConstraints.runback);
    } else if (selectedSport.sport?.toLowerCase() === 'mlb' && selectedSite.site) {
      setStackExposures(mlbStacks[selectedSite.site?.toLowerCase()], { primary: '', secondary: 0, percent: 0 });
    } else {
      setStackExposures(initialConstraintState, { primary: '', secondary: 0, percent: .25 });
    }
  }, [selectedSport, selectedSite])

  React.useEffect(() => {
    const statusCall = async () => {
      setHasPreviousSim(false);
      const progress = await fetch(
        `${baseUrl}/api/contests/getSimulationStatus?SlateId=${selectedSlate?.slateId || 0
        }&User=${auth}&StatusType=ContestGen`
      ).then((res) => res.json());

      if (progress.progress === 1) {
        setHasPreviousSim(true);
      }
    };

    if (selectedSlate.slateId) {
      statusCall();
    }
  }, [selectedSlate]);

  React.useEffect(() => {
    const savedTeamControl = localStorage.getItem(savedTeamControlKey);
    if (savedTeamControl) {
      dispatch(setRemovedTeamsAction(savedTeamControl ? savedTeamControl.split(',') : []));
    }
  }, [selectedSlate, selectedSite, selectedSport]);

  if (authenticated.status === APIConstants.STARTED || slatesLoading) {
    return (
      <SettingsLoader />
    )
  }
  

  if (!isUserSubscribed) {
    return (
      <UnauthenticatedView
        title='Contest Settings'
        app='CONTESTGEN'
        backgroundColor='rgba(0, 118, 54, 0.15)'
      />
    )
  }

  if (!slatesLoading && (!slates || (slates && filterSlates(slates, selectedSport, selectedSite, selectedType)?.length === 0))) {
    return (
      <NoSlatesView title='Contest Settings' app='CONTESTGEN' backgroundColor='rgba(0, 118, 54, 0.15)' />
    )
  }

  return (
    <Grid container className={`${classes.root} ${hideSettings ? classes.clear : ''}`}>
      <UpgradeModal open={openModal} onClose={() => setOpenModal(false)} />
      <Grid container >
        <Grid item xs={12} container className={`${classes.heading} ${hideSettings ? 'hide' : ''}`}>
          <Stack direction='row' flexWrap='wrap' alignItems='center' justifyContent='space-between' width='100%'>
            <Stack direction='row' flexWrap='wrap' alignItems='top' width='100%' columnGap={1}>
              <SettingsSelectors app='CONTESTGEN'/>
              <SelectInput
                bottomLabel={toolTipText.poolSize}
                data={
                  poolSizeOptions(
                    selectedSport.sport?.toLowerCase(),
                    selectedSlate.type?.toLowerCase(),
                    50001,
                    selectedSlate.allowedEntryCounts,
                    authenticated?.data?.authTier
                  )
                }
                label="Pool Size"
                value={poolSize}
                onSelect={(selection: any) => setSize(selection.value)}
                tierLock={tierLocked}
              />
              <Stack direction='row' justifyContent='space-between' mr='2px'>
                {selectedSlate.sport === selectedSport.sport && selectedSlate.matchupInfo && (
                  <Stack direction={'column'} display={'flex'} alignItems={'start'}>
                    <CustomToolTip title={toolTipText.teamControls}>
                      <TooltipSelectLabelStyledTypography>Team Controls</TooltipSelectLabelStyledTypography>
                    </CustomToolTip>
                    <GameControls variant="contained" boostOwnership={playersLoaded} localStorageKey={savedTeamControlKey} onBoostApply={handleBoost} />
                  </Stack>
                )}
              </Stack>
              {
                showStackTabContestGen(selectedSlate) && selectedSlate.type?.toUpperCase() !== 'SHOWDOWN' && (
                  <Stack direction={'column'} display={'flex'} alignItems={'start'}>
                    <CustomToolTip title={toolTipText.stackTypeExposures}>
                      <TooltipSelectLabelStyledTypography>Stack Type Exposures</TooltipSelectLabelStyledTypography>
                    </CustomToolTip>
                    <StackConstraints
                      savedStackConstraintKey={savedStackConstraintKey}
                      constraints={stackConstraints}
                      runback={runback}
                      defaultConstraints={selectedSport.sport?.toLowerCase() === 'mlb' && selectedSite.site ? (mlbStacks[selectedSite.site.toLowerCase()] ?? initialConstraintState) : initialConstraintState}
                      defaultRunback={selectedSport.sport?.toLowerCase() === 'mlb' ? { primary: '', secondary: 0, percent: 0 } : { primary: 0, secondary: 0, percent: .25 }}
                      onApply={(newConstraints: StackConstraint[], runback: StackConstraint, useCustomExposure: boolean) => setStackExposures(newConstraints, runback)}
                      sport={selectedSport?.sport}
                      useCustomExposures={useCustomExposures}
                    />
                  </Stack>

                )
              }
              {
                selectedSlate?.sport?.toLowerCase() === 'mma' && (
                  <FightStackSettingsAdjuster stackSettings={fightStacks} setStackSettings={(newSettings) => handleFightStacksChange(newSettings)} />
                )
              }
              {
                (!['mma', 'mlb'].includes(selectedSlate.sport?.toLowerCase()) || (process.env.NODE_ENV !== 'production' || document.location.hostname.includes('dev.tools'))) && (
                  <Stack direction={'column'} width={173} marginRight="4px" marginLeft="4px" mt='4px' className={classes.sliderWrapper} color={'white'} textAlign='center'>
                    <CustomToolTip title={toolTipText.contestArchetype}>
                      <TooltipSelectLabelStyledTypography>Contest Archetype</TooltipSelectLabelStyledTypography>
                    </CustomToolTip>
                    <Box padding="0 16px">
                      <Slider
                        defaultValue={diversity}
                        value={diversity}
                        onChange={(e, value) => setDiversity(value)}
                        min={-2}
                        max={2}
                        aria-labelledby="discrete-slider-custom"
                        step={1}
                        marks={marks}
                        track={false}
                      />
                    </Box>
                  </Stack>
                )
              }
              <Hidden mdDown>
                <Stack direction='column' ml='auto' rowGap={1} alignItems='end' height={'100%'}>
                  <Stack ml={2}>
                    {updateInfo?.projectionsLastUpdated && <Box fontSize={10} color={'#BCBCBC'} paddingRight={2} textAlign={'end'}>Projections Last Updated: {moment.utc(updateInfo?.projectionsLastUpdated).local().format('M/D h:mm A')}</Box>}
                    {updateInfo?.ownershipLastUpdated && <Box fontSize={10} color={'#BCBCBC'} paddingRight={2} textAlign={'end'}>Ownership Last Updated: {moment.utc(updateInfo?.ownershipLastUpdated).local().format('M/D h:mm A')}</Box>}
                  </Stack>
                  <Stack direction='row' columnGap={1} className={classes.buttonWrapper}>
                    <Button variant='contained' size='small' className={`${classes.button} ${hideSettings ? 'hide' : ''}`} onClick={() => onGenerate()} disabled={loading || disableGenerate}>
                      Generate Lineups
                    </Button>
                    {
                      hasPreviousSim && (
                        <Button variant='outlined' size='small' style={{ color: 'white', border: '1px solid #0042C1', padding: 0 }} onClick={() => bringBack()} >
                          <Box display="flex" flexDirection="column" fontSize="12px" padding="5px 16px">
                            <div>Restore Last Pool</div>
                            <div style={{ fontSize: '10px', lineHeight: .75, opacity: 0.7 }}>{getCookie(lastGenerationTimestampCookieKey)}</div>
                          </Box>
                        </Button>
                      )
                    }
                  </Stack>
                </Stack>
              </Hidden>
              <Hidden mdUp>
                <Stack direction='row' alignItems='center' justifyContent='space-between' flexGrow={1} mt="8px">
                  <Stack direction='row' columnGap={1} className={classes.buttonWrapper}>
                    <Button variant='contained' size='small' className={`${classes.button} ${hideSettings ? 'hide' : ''}`} onClick={() => onGenerate()} disabled={loading || disableGenerate}>
                      Generate Lineups
                    </Button>
                    {
                      hasPreviousSim && (
                        <Button variant='outlined' size='small' style={{ color: 'white', border: '1px solid #0042C1', padding: 0 }} onClick={() => bringBack()} >
                          <Box display="flex" flexDirection="column" fontSize="12px" padding="5px 16px">
                            <div>Restore Last Pool</div>
                            <div style={{ fontSize: '10px', lineHeight: .75, opacity: 0.7 }}>{getCookie(lastGenerationTimestampCookieKey)}</div>
                          </Box>
                        </Button>
                      )
                    }
                  </Stack>
                </Stack>
              </Hidden>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  )
}

const mapStateToProps = (state: any) => {
  const {
    boostedPlayers,
    poolSize,
    loading,
    stackConstraints,
    runback,
    contestLineups,
    diversity,
    fightStacks,
    useCustomExposures,
  } = state.contestGenerator;

  const {
    authenticated,
    selectedSport,
    selectedSite,
    selectedType,
    selectedSlate,
  } = state.common;

  return {
    selectedSport,
    selectedSite,
    selectedType,
    selectedSlate,
    contestLineups,
    authenticated,
    boostedPlayers,
    poolSize,
    loading,
    stackConstraints,
    runback,
    diversity,
    fightStacks,
    useCustomExposures,
  }
}


const mapDispatchToProps = {
  SetSport: setSport,
  SetSite: setSite,
  SetSlate: setSlate,
  SetGeneratedSlate: setGeneratedSlate,
  TriggerContestGen: triggerContestGen,
  SetFightStacks: setFightStacks,
  SetPoolSize: setPoolSize,
  SetConstraints: setConstraints,
  SetRunback: setRunback,
  GetContestPlayers: getContestPlayers,
  GetContestLineups: getContestLineups,
  GetContestStacks: getContestStacks,
  SetBoostedPlayer: setBoostedPlayer,
  ClearBoostedPlayers: clearBoostedPlayer,
  SetDiversity: setDiversity,
  RemoveBoostedPlayer: removeBoostedPlayer,
  UseCustomExposures: setUseCustomExposures
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
